import { ModuleList } from '../../../shared/analytics/module-list';
import { pagesConfig } from '../../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import TransferLogsGrid from './calendar-transfer-logs-grid';

export default function TransferLogsGridPage() {
  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.calendars.name },
        { label: pagesConfig.calendarTransferLogs.name },
      ]}
      bookmarkKey={pagesConfig.calendarTransferLogs.value}
    >
      <TransferLogsGrid />
    </SimpleBreadcrumbsPage>
  );
}
